<template>
  <div class="ai_warn_list" v-loading="loading">
    <el-card class="box-card">
			<el-form :model="pageInfo" label-width="80" class="whereclass">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="起始时间" prop="date">
              <el-date-picker
                v-model="date"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报警类型" prop="type">
              <el-select v-model="pageInfo.type" placeholder="请选择">
                <el-option
                  v-for="item in whereOption.typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报警接收" prop="ste">
              <el-select v-model="pageInfo.ste" placeholder="请选择">
                <el-option
                  v-for="item in whereOption.steOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>

			</el-form>
		</el-card>

    <div class="body_con">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-table :data="tableData" style="width: 100%" @row-click="openDetails">
            <el-table-column prop="target_begin_time" label="报警时间" width="140"></el-table-column>
            <el-table-column prop="title" label="报警摄像头"></el-table-column>
            <el-table-column prop="number" label="摄像头编号"></el-table-column>
            <el-table-column prop="target_name" label="报警摘要"> </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageInfo.page"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="pageInfo.pageSize"
            layout="sizes, total, prev, pager, next, jumper"
            :total="cnt_all"
          >
          </el-pagination>
        </el-col>
        <el-col :span="8">
          <div class="pic_view"><img :src="nowBaojingPic" /></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import aiListApi from "@/api/aivideo/aiList"
export default {
  name: "deviceList",
  props: {
    userId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      whereOption: {
        steOptions: [
          {
            value: '0',
            label: '未处理'
          },
          {
            value: '1',
            label: '已处理'
          },
          {
            value: '2',
            label: '误报'
          }
        ],
        typeOptions: [
          {
            value: '0',
            label: '进入'
          },
          {
            value: '1',
            label: '离开'
          },
          {
            value: '2',
            label: '停车'
          }
        ]
      },
      date: ['',''],
      pageInfo: {
        page: 1,
        pageSize: 20,
        begin_time:'',
        end_time:'',
        type:'',
        ste:''
      },
      cnt_all: 0,
      nowBaojingPic: ''
    };
  },
  methods: {
    getTableData(pageIndex) {
      this.loading = true;
      this.pageInfo.page = pageIndex;
      this.pageInfo.begin_time = this.date[0].toString();
      this.pageInfo.end_time = this.date[1].toString();
      console.log('this.pageInfo',this.pageInfo)
      aiListApi.getAiListApi(this.pageInfo).then((res) => {
        this.loading = false;
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.tableData = resData.list;
          if(resData.list.length){
            this.nowBaojingPic = resData.list[0].picture
          }
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openDetails (row) {
      this.nowBaojingPic = row.picture
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less'>
.ai_warn_list {
  width: 100%;
  height:100%;
  .el-card__body{
    padding-bottom: 5px !important;
  }
  .whereclass {
    .el-input__inner{
      height:34px !important;
      line-height: 34px !important;
      width:250px !important;
      .el-range-separator{
        line-height: 26px !important;
      }
    }
  }
  .body_con{
    .pic_view{
      margin-top:50px;
      img{
        width:100%;
        height:auto;
      }
    }
  }
}
</style>
